import { Component } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { GlobalVariables } from '../../constants/global-constants';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [
    MatSelectModule,
    MatFormFieldModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
  countries = GlobalVariables.countries;
  languageSelectTooltip = GlobalVariables.Select_Language_Tooltip_Message;
  currCountry: CountryData;


  constructor(private languageService: LanguageService) {
    var initialCountry = this.countries.filter((x: CountryData) => window.location.href.indexOf('/' + x.languageCd + '/') > 0)[0];
    if (initialCountry) {
      this.currCountry = initialCountry
    }
    else {
      this.currCountry = this.countries[0];
    }
  }

  selectionChange(countryCd: string) {
    if (countryCd) {
      this.languageService.locale = countryCd;
      this.languageService.changeLanguage(countryCd);
    }
  }
}
interface CountryData {
  Name: string,
  languageCd: string,
  flagImage: string
}
